import React, { useEffect, useState } from 'react'
import { getaxiosRequestWithToken, postaxiosadminRequestWithToken, postAdminFileWithToken } from '../../../api/api'
import CommonSpinner from '../../../services/commonSpinner'
import { FaEdit, FaEye, FaUserCircle } from "react-icons/fa";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import showToast from '../../../services/toastifyservices';
import { handleSession } from './../../../api/apiSessionHandle';
import { useNavigate } from "react-router-dom";
import { PaginationControls } from '../../../components/pagination';
import endpoints from '../../../api/EndPoints';


const ManagePractices = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [allPractices, setAllPractices] = useState([])
    const [editModal, setEditModal] = useState(false)
    const [emailError, setEmailError] = useState("");
    const [phoneErrors, setPhoneErrors] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedPractice, setSelectedPractice] = useState("")
    const [initialUpdateForm, setInitialUpdateForm] = useState({});
    const [addModal, setAddModal] = useState(false);

    //! Pagination state
    const [currentPage, setCurrentPage] = useState();
    const [rowsPerPage, setRowsPerPage] = useState();
    const [totalPages, setTotalPages] = useState();
    const [selectedFile, setSelectedFile] = useState(null);


    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            fetchPractices(page);
        }
    };
    //! handle rows per page
    const handleRowsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value, 10);
        setRowsPerPage(newLimit);
        fetchPractices(currentPage, newLimit);
    };


    const [updateForm, setUpdateForm] = useState({
        name: "",
        email: "",
        phone: "",
        //password: "",
        address: "",
        status: "",
        profile_image: null,
    });

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        address: "",
        status: "",
        profile_image: "",
        password: ""
    });

    const validateForm = (form) => {
        const errors = {};

        if (!form.name || !form.name.trim()) {
            errors.name = "Name is required.";
        }

        if (!form.email || !form.email.trim()) {
            errors.email = "Email is required.";
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email)) {
            errors.email = "Invalid email format.";
        }

        if (!form.phone || !form.phone.trim()) {
            errors.phone = "Phone number is required.";
        } else {
            const numericPhone = form.phone.replace(/\D/g, "");
            if (numericPhone.length !== 10) {
                errors.phone = "Phone number must be 10 numbers";
                showToast("error", "Phone number must be of 10 numbers");
            }
        }

        if (!form.password || !form.password.trim()) {
            errors.password = "Password is required.";
        } else if (form.password.length < 6) {
            errors.password = "Password must be at least 6 characters.";
        }

        if (!form.address || !form.address.trim()) {
            errors.address = "Address is required.";
        }

        if (!form.status || !form.status.trim()) {
            errors.status = "Status is required.";
        }

        if (!form.profile_image || !form.profile_image) {
            errors.profile_image = "Profile image is required.";
        }

        setErrors(errors);
        return errors;
    };




    const validateEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailPattern.test(email);
    };

    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === "email") {
            if (value === "") {
                setEmailError(""); // Clear error if the field is empty
            } else if (!validateEmail(value)) {
                setEmailError("Invalid email format");
            } else {
                setEmailError("");
            }
        }

        if (name === "phone") {
            // Remove all non-numeric characters
            value = value.replace(/\D/g, "");

            if (value === "") {
                setPhoneErrors({}); // Clear phone error if the field is empty
            } else {
                // Format as (XXX) XXX-XXXX while typing
                if (value.length > 3 && value.length <= 6) {
                    value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
                } else if (value.length > 6) {
                    value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
                        6,
                        10
                    )}`;
                }

                // Validation check for full 10-digit phone number
                if (value.length < 14) {
                    setPhoneErrors({ phone: "Invalid US phone number format" }); // Set phone error
                } else {
                    setPhoneErrors({}); // Clear phone error
                }
            }
        }
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        // Update form state
        setUpdateForm((prev) => ({ ...prev, [name]: value }));
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            setUpdateForm((prev) => ({ ...prev, profile_image: file }));
            setFormData((prev) => ({ ...prev, profile_image: file }));
        };

        if (errors.profile_image) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors["profile_image"];
                return newErrors;
            });
        }

    };

    const fetchPractices = async (page) => {
        setLoading(true)
        const payload = { page: page }
        try {
            const response = await postaxiosadminRequestWithToken(endpoints.practices, payload)
            if (response) {
                setAllPractices(response.data.data)
                setRowsPerPage(response.data.per_page);
                setCurrentPage(response.data.current_page);
                setTotalPages(Math.ceil(response.data.total / response.data.per_page));
            }
        }
        catch (error) {
            showToast(
                "error",
                error.response?.data?.message || "Something went wrong."
            );
            handleSession(error.response?.data, navigate);
        }
        finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        fetchPractices()
    }, [])

    useEffect(() => {
        setUpdateForm(initialUpdateForm)
    }, [initialUpdateForm])

    const handleEdit = (data) => {
        setEditModal(true)
        setSelectedPractice(data)
        const initialData = {
            id: data.id,
            name: data.name || "",
            address: data.address || "",
            email: data.email || "",
            phone: data.phone || "",
            status: data.status || "",
            profile_image: data.profile_image || "",
            //password: data.password || ""
        };
        setInitialUpdateForm(initialData);
        //setUpdateForm(initialData)
        //setFormData(initialData);
    }


    const handleUpdate = async () => {

        if (!validateForm(updateForm)) {
            return
        }
        const { name, email, phone, password, address, status, profile_image } = updateForm;

        // Check if any field is empty
        if (!name || !email || !phone || !address || !status || !profile_image) {
            showToast("error", "Please fill all the required fields to update a practice.");
            return;
        }
        setLoading(true);
        try {
            const response = await postAdminFileWithToken(
                `${endpoints.UpdatePractice}/${selectedPractice.id}`,
                updateForm
            );
            if (response) {
                showToast("success", response.message);
                setEditModal(false)
                setFormData("");
                await fetchPractices()
            }
        }
        catch (error) {
            showToast("error", error.response?.data.message);
            handleSession(error.response?.data, navigate);
        }
        finally {
            setLoading(false)
        }

    };
    const handleAddPractice = async () => {

        if (!validateForm(formData)) {
            return
        }
        const { name, email, phone, password, address, status, profile_image } = formData;

        // Check if any field is empty
        if (!name || !email || !phone || !password || !address || !status || !profile_image) {
            showToast("error", "Please fill all the required fields to add a practice.");
            return;
        }
        setLoading(true);
        try {
            const response = await postAdminFileWithToken(endpoints.AddPractise, formData);
            if (response) {
                showToast("success", response.message);
                setAddModal(false);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    password: "",
                    address: "",
                    status: "",
                    profile_image: "",
                });
                await fetchPractices();
            }
        } catch (error) {
            showToast("error", error.response?.data.message);
            handleSession(error.response?.data, navigate);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="mt-3 p-2 md:p-10 bg-gray-200">
            <div className="card">
                <span className="text-start font-bold ml-4 p-2 headingtext">
                    Manage Practice
                </span>
            </div>
            <div className="card p-3">
                <div className="flex  justify-end mr-3">
                    <button
                        className="flex align-items-center btn btn-primary fw-bold btncolor py-2"
                        onClick={() => setAddModal(true)}
                    >
                        Add New Practice
                    </button>
                </div>
            </div>
            <div className="card">
                <div className="table-container">
                    <table className="table table-striped table-hover">
                        <thead className="table-header table-primary">
                            <tr>
                                <th>Image</th>
                                <th>Provider Name</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allPractices.map((data) => (
                                <tr key={data.id}>
                                    <td>
                                        <div
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                borderRadius: "50%",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#f0f0f0",
                                            }}
                                        >
                                            {data ? (
                                                <img
                                                    src={data.profile_image}
                                                    alt={data.name}
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null; // Prevent infinite loop
                                                        e.target.style.display = "none"; // Hide broken image
                                                    }}
                                                />
                                            ) : (
                                                <FaUserCircle size={100} color="#ccc" />
                                            )}
                                        </div>
                                    </td>
                                    <td className="align-middle text-capitalize">{data.name}</td>
                                    <td className="align-middle">{data.email}</td>
                                    <td className="align-middle text-capitalize">
                                        {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                                    </td>

                                    <td className="align-middle">
                                        <div className="d-flex gap-2">
                                            <button
                                                onClick={() => handleEdit(data)}
                                                className="btn btn-sm btn-primary"
                                            >
                                                <FaEdit style={{ cursor: "pointer" }} />{" "}
                                            </button>

                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <Modal
                show={editModal}
                onHide={() => {
                    setEditModal(false);
                    setUpdateForm(initialUpdateForm);
                    setEmailError("");
                    setPhoneErrors({});
                    setErrors({})
                }}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Practice</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <Form>
                        {[
                            ["name", "email"],
                            ["phone", "status"],
                            ["address", "profile_image"],
                        ].map((pair, index) => (
                            <div className="row mb-3" key={index}>
                                {pair.map((key) => (
                                    <div className="col-md-6" key={key}>
                                        <Form.Group>
                                            {key !== "profile_image" && (
                                                <Form.Label className="fw-bold">
                                                    {key.replace("_", " ").toUpperCase()}
                                                    <span className="text-danger">*</span>
                                                </Form.Label>
                                            )}

                                            {key === "status" ? (
                                                <>
                                                    <Form.Select
                                                        name={key}
                                                        value={updateForm[key]}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                    </Form.Select>
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                </>
                                            ) : key === "email" ? (
                                                <>
                                                    <Form.Control
                                                        type="email"
                                                        name={key}
                                                        value={updateForm[key]}
                                                        onChange={handleChange}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                    {emailError && (
                                                        <div className="text-danger">{emailError}</div>
                                                    )}
                                                </>
                                            ) : key === "phone" ? (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        name={key}
                                                        value={updateForm[key] || ""}
                                                        onChange={handleChange}
                                                        className={phoneErrors.phone ? "is-invalid" : ""}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                    {phoneErrors.phone && (
                                                        <div className="text-danger">{phoneErrors.phone}</div>
                                                    )}
                                                </>
                                            ) : key === "profile_image" ? (
                                                <>

                                                    <Form.Label className="fw-bold me-2 mb-0">
                                                        Profile Picture:
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        onChange={handleFileChange}
                                                        accept="image/png, image/jpeg, image/jpg"
                                                        className="mt-2"
                                                    />
                                                    {errors.profile_image && (
                                                        <Form.Control.Feedback type="invalid" className="d-block">
                                                            {errors.profile_image}
                                                        </Form.Control.Feedback>
                                                    )}
                                                    <div className="d-flex align-items-end ml-auto mt-2">


                                                        {updateForm.profile_image instanceof File ? (
                                                            <img
                                                                src={URL.createObjectURL(updateForm.profile_image)}
                                                                alt="Preview"
                                                                className="ms-2"
                                                                style={{
                                                                    width: "90px",
                                                                    height: "90px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#f0f0f0",
                                                                }}
                                                            />
                                                        ) : typeof updateForm.profile_image === "string" &&
                                                            updateForm.profile_image ? (
                                                            <img
                                                                src={updateForm.profile_image}
                                                                alt="Profile"
                                                                className="ms-2"
                                                                style={{
                                                                    width: "90px",
                                                                    height: "90px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#f0f0f0",
                                                                }}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        name={key}
                                                        value={updateForm[key]}
                                                        onChange={handleChange}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                </>
                                            )}
                                        </Form.Group>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setEditModal(false);
                            setEmailError("");
                            setPhoneErrors({});
                            setErrors({})
                        }}
                    >
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleUpdate} disabled={loading}>
                        {loading ? (
                            <>
                                <Spinner animation="border" size="sm" /> Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={addModal} // Define this state
                onHide={() => {
                    setAddModal(false);
                    setFormData({
                        name: "",
                        email: "",
                        phone: "",
                        password: "",
                        address: "",
                        status: "",
                        profile_image: null,
                    });
                    setEmailError("");
                    setPhoneErrors({});
                    setErrors({})
                }}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Practice</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <Form>
                        {[
                            ["name", "email"],
                            ["phone", "status"],
                            ["address", "password"],
                            ["profile_image"],
                        ].map((pair, index) => (
                            <div className="row mb-3" key={index}>
                                {pair.map((key) => (
                                    <div
                                        className="col-md-6"
                                        key={key}
                                    >
                                        <Form.Group>
                                            {key !== "profile_image" && (
                                                <Form.Label className="fw-bold">
                                                    {key.replace("_", " ").toUpperCase()}
                                                    <span className="text-danger">*</span>
                                                </Form.Label>
                                            )}

                                            {key === "status" ? (
                                                <>
                                                    <Form.Select
                                                        name={key}
                                                        value={formData[key]}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value="active">Active</option>
                                                        <option value="inactive">Inactive</option>
                                                    </Form.Select>
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                </>
                                            ) : key === "email" ? (
                                                <>
                                                    <Form.Control
                                                        type="email"
                                                        name={key}
                                                        value={formData[key]}
                                                        onChange={handleChange}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                    {emailError && (
                                                        <div className="text-danger">{emailError}</div>
                                                    )}
                                                </>
                                            ) : key === "phone" ? (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        name={key}
                                                        value={formData[key] || ""}
                                                        onChange={handleChange}
                                                        className={phoneErrors.phone ? "is-invalid" : ""}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                    {phoneErrors.phone && (
                                                        <div className="text-danger">{phoneErrors.phone}</div>
                                                    )}
                                                </>
                                            ) : key === "password" ? (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        name={key}
                                                        value={formData[key]}
                                                        onChange={handleChange}
                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                </>
                                            ) : key === "profile_image" ? (
                                                <>
                                                    <Form.Group controlId="profileImage">
                                                        <div className="d-flex align-items-center">
                                                            <Form.Label className="fw-bold me-2 mb-0">
                                                                Profile Picture:
                                                            </Form.Label>

                                                            {formData.profile_image instanceof File ? (
                                                                <img
                                                                    src={URL.createObjectURL(formData.profile_image)}
                                                                    alt="Preview"
                                                                    className="ms-2"
                                                                    style={{
                                                                        width: "90px",
                                                                        height: "90px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: "#f0f0f0",
                                                                    }}
                                                                />
                                                            ) : typeof formData.profile_image === "string" &&
                                                                formData.profile_image ? (
                                                                <img
                                                                    src={formData.profile_image}
                                                                    alt="Profile"
                                                                    className="ms-2"
                                                                    style={{
                                                                        width: "90px",
                                                                        height: "90px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: "#f0f0f0",
                                                                    }}
                                                                />
                                                            ) : null}
                                                        </div>

                                                        <Form.Control
                                                            type="file"
                                                            onChange={handleFileChange}
                                                            accept="image/png, image/jpeg, image/jpg"
                                                            className="mt-2"
                                                        />
                                                        {errors.profile_image && (
                                                            <Form.Control.Feedback type="invalid" className="d-block">
                                                                {errors.profile_image}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </Form.Group>
                                                </>
                                            ) : (
                                                <>
                                                    <Form.Control
                                                        type="text"
                                                        name={key}
                                                        value={formData[key]}
                                                        onChange={handleChange}

                                                    />
                                                    {errors[key] && (
                                                        <div className="text-danger">{errors[key]}</div>
                                                    )}
                                                </>
                                            )}
                                        </Form.Group>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setAddModal(false)
                            setErrors({})
                            setFormData({})
                        }
                        }
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleAddPractice}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner animation="border" size="sm" /> Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {loading ? null : (
                <div className="pagination-controls">
                    <PaginationControls
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        rowsPerPage={rowsPerPage}
                        onLimitPerPage={handleRowsPerPageChange}
                    />
                </div>
            )}

            {loading && <CommonSpinner />}
        </div>
    )
}

export default ManagePractices
